import * as Types from '../../../../graphql-types'

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type AddReviewMutationVariables = Types.Exact<{
  orderId: Types.Scalars['String']
  foodQuality: Types.Scalars['Int']
  restaurantService: Types.Scalars['Int']
  deliveryTime?: Types.InputMaybe<Types.Scalars['Int']>
  reviewText?: Types.InputMaybe<Types.Scalars['String']>
}>

export type AddReviewMutation = {
  addReview: {
    __typename: 'AddReviewResponse'
    message: string
    review: { __typename: 'Review'; id: string; status: Types.ReviewStatus }
  }
}

export const AddReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'foodQuality' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'restaurantService' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'deliveryTime' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'reviewText' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'foodQuality' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'foodQuality' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'restaurantService' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'restaurantService' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deliveryTime' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'deliveryTime' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reviewText' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'reviewText' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddReviewMutation, AddReviewMutationVariables>
